import { SnackbarOrigin } from "@mui/material";
import { getMyRoles } from "api/Auth/useAuth";
import { getUserAccountMe } from "api/user_accounts"; // Добавьте этот импорт
import { RoleCode, RoleMenu, RoleMenuHeader } from "constants/constant";
import i18n from "i18n";
import { makeAutoObservable, runInAction, toJS } from "mobx";
import printJS from "print-js";
import pages, { icons } from "./menu-items/pages";
import TechCouncilSection from "./layouts/MainLayout/Header/TechCouncilSection";
import dayjs, { Dayjs } from "dayjs";

// Добавьте интерфейс для данных пользователя
export interface UserAccountPublic {
  username: string;
  full_name: string;
  position: string;
  has_signing_rights: boolean;
  is_active: boolean;
  organization_name: string;
  role_code: string;
}

class NewStore {
  loader_counter = 0;
  loader = false;
  openSnackbar = false;
  positionSnackbar: SnackbarOrigin = { vertical: "bottom", horizontal: "center" };
  snackbarMessage = "";
  snackbarSeverity: "success" | "info" | "warning" | "error" = "success";
  alert = {
    messages: [],
    titles: [],
  };
  digitalSign = {
    open: false,
    fileId: 0,
    onCloseYes: null,
    onCloseNo: null,
    uplId: 0,
  };
  confirm = {
    errorMessage: [],
    alertYesNo: [],
    bodies: [],
    acceptBtnColor: [],
    cancelBtnColor: [],
    acceptBtnCustomIcon: [],
    cancelBtnCustomIcon: [],
    cancelBtn: [],
    acceptBtn: [],
    onCloseYes: [],
    onCloseNo: [],
    isDeleteReason: [],
  };
  error = {
    openError403: { error: false, message: "" },
    openError422: { error: false, message: "" },
  };
  myRoles: string[] = [];
  isAdmin = false;
  isEmployee = false;
  CountAppsFromCabinet = 0;
  BackUrl = '';
  curentUserPin: string = "";
  
  // Добавьте новое поле для данных пользователя
  currentUser: UserAccountPublic;

  menu = [];
  menuHeader = [];

  constructor() {
    makeAutoObservable(this);
  }

  // Добавьте метод для получения данных пользователя
  async getCurrentUser() {
    try {
      const response = await getUserAccountMe();
      if ((response.status === 201 || response.status === 200) && response?.data !== null) {
        runInAction(() => {
          this.currentUser = response.data;
          // Опционально: можете сохранить PIN из username
          this.curentUserPin = response.data.username;
        });
        return true;
      } else {
        throw new Error();
      }
    } catch (err) {
      MainStore.setSnackbar(i18n.t("message:cannotLoadUserData"), "error");
      return false;
    }
  }

  // Добавьте метод для инициализации при логине
  async initializeUser() {
    try {
      // Загружаем данные пользователя и роли параллельно
      await Promise.all([
        this.getCurrentUser(),
        // this.getMyRoles()
      ]);
      return true;
    } catch (err) {
      console.error("Error initializing user:", err);
      return false;
    }
  }

  // Добавьте метод для очистки данных при logout
  clearUserData() {
    this.currentUser = null;
    this.curentUserPin = "";
    this.myRoles = [];
    this.isAdmin = false;
    this.isEmployee = false;
  }

  setOpenError403 = (flag: boolean, message?: string) => {
    this.error.openError403.error = flag;
    if (flag === false) {
      this.error.openError403.message = "";
    } else {
      this.error.openError403.message = message;
    }
  };

  setOpenError422 = (flag: boolean, message?: string) => {
    this.error.openError422.error = flag;
    if (flag === false) {
      this.error.openError422.message = "";
    } else {
      this.error.openError422.message = message;
    }
  };

  logoutNavigate = () => {
    if (window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
    this.clearUserData(); // Очищаем данные при logout
  };

  changeSnackbar = (flag: boolean) => {
    this.openSnackbar = flag;
    if ((flag = false)) {
      this.snackbarMessage = "";
      this.snackbarSeverity = "success";
    }
  };

  changeCurrentuserPin = (pin: string) => {
    this.curentUserPin = pin;
  }

  setSnackbar(
    message: string,
    severity: "success" | "info" | "warning" | "error" = "success",
    position?: SnackbarOrigin
  ) {
    this.openSnackbar = true;
    this.snackbarMessage = message;
    this.snackbarSeverity = severity;
    if (position) {
      this.positionSnackbar = position;
    }
  }

  async getMyRoles() {
    try {
      const response = await getMyRoles();
      if ((response.status === 201 || response.status === 200) && response?.data !== null) {
        runInAction(() => {
          this.myRoles = response.data;
          this.myRoles.forEach((element) => {
            if (element === RoleCode.ADMIN) {
              this.isAdmin = true;
            } else if (element === RoleCode.EMPLOYEE) {
              this.isEmployee = true;
            }
          });
        });
        this.createMenuFromRole();
        this.crateHeaderMenu();
      } else {
        throw new Error();
      }
    } catch (err) {
      MainStore.setSnackbar(i18n.t("message:cannotLoadNotifications"), "error");
    }
  }

  createMenuFromRole() {
    let pageMenu = pages.children;
    console.log("=== DEBUG MENU ===");
    console.log("pages:", pages);
    console.log("pages.children:", pageMenu);
    
    const allMenuItems = pageMenu.flatMap(group => group.children || []);
    console.log("allMenuItems:", allMenuItems);
    
    this.menu = allMenuItems;
    console.log("this.menu после установки:", this.menu);
    console.log("=== END DEBUG ===");
  }

  crateHeaderMenu() {
    let pageMenu = pages.children;
    runInAction(() => {
      this.menuHeader = [];
    })
  }

  openErrorDialog = (message: string, title?: string) => {
    this.alert.messages.push(message);
    if (title) this.alert.titles.push(title);
  };

  openDigitalSign = (
    fileId: number,
    yesCallback: any,
    noCallback: any,
  ) => {
    this.digitalSign.open = true;
    this.digitalSign.fileId = fileId;
    this.digitalSign.onCloseYes = yesCallback;
    this.digitalSign.onCloseNo = noCallback;
  };

  openErrorConfirm = (
    message: string,
    yesLabel: string,
    noLabel: string,
    yesCallback: any,
    noCallback: any,
    yesIcon?: any,
    noIcon?: any,
    yesColor?: string,
    noColor?: string,
    isDeleteReason?: boolean
  ) => {
    this.confirm.errorMessage.push(message);
    this.confirm.acceptBtn.push(yesLabel);
    this.confirm.cancelBtn.push(noLabel);
    this.confirm.onCloseYes.push(yesCallback);
    this.confirm.onCloseNo.push(noCallback);
    this.confirm.acceptBtnColor.push(yesColor);
    this.confirm.cancelBtnColor.push(noColor);
    this.confirm.acceptBtnCustomIcon.push(yesIcon);
    this.confirm.cancelBtnCustomIcon.push(noIcon);
    this.confirm.isDeleteReason.push(isDeleteReason);
  };

  onCloseAlert = () => {
    if (this.alert.messages.length > 0) this.alert.messages.shift();
    if (this.alert.titles.length > 0) this.alert.titles.shift();
  };

  onCloseConfirm = () => {
    if (this.confirm.errorMessage.length > 0) {
      this.confirm.errorMessage.shift();
      this.confirm.acceptBtn.shift();
      this.confirm.cancelBtn.shift();
      this.confirm.onCloseYes.shift();
      this.confirm.onCloseNo.shift();
      this.confirm.acceptBtnColor.shift();
      this.confirm.cancelBtnColor.shift();
      this.confirm.acceptBtnCustomIcon.shift();
      this.confirm.cancelBtnCustomIcon.shift();
    }
  };

  formatDate(date: Dayjs | null | undefined): string | null {
    if (!date) return null;
    if (!dayjs(date).isValid()) return null;
    return dayjs(date).format("YYYY-MM-DDTHH:mm:ss");
  }

  onCloseDigitalSign = () => {
    this.digitalSign.open = false;
    this.digitalSign.onCloseYes = null;
    this.digitalSign.onCloseNo = null;
    this.digitalSign.fileId = 0;
    this.digitalSign.uplId = 0;
  };

  changeLoader(flag: boolean) {
    if (flag) {
      this.loader_counter += 1;
    } else {
      this.loader_counter -= 1;
    }
    if (this.loader_counter <= 0) {
      this.loader = false;
      this.loader_counter = 0;
    } else this.loader = true;
  }
}

const MainStore = new NewStore();
export default MainStore;